import * as React from 'react';

interface IPikIconProps {
  className?: string;
}

export function PikIcon(props: IPikIconProps) {
  return <img className={props.className} src="https://cdn.cian.site/media/images/pik_orange.svg" alt="ПИК" />;
}
